import { render, staticRenderFns } from "./radish-portrait.vue?vue&type=template&id=2ab57054"
import script from "./radish-portrait.vue?vue&type=script&lang=js"
export * from "./radish-portrait.vue?vue&type=script&lang=js"
import style0 from "./radish-portrait.vue?vue&type=style&index=0&id=2ab57054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports